/* eslint-disable no-unused-vars */
export enum WrapHeaderActionEnum {
  cargoesFreeText_onSearch = 'cargoesFreeText_onSearch',
  button_click = 'button_click',
}

export interface WrapHeaderModel {
  cargoesTitle?: {
    text: string;
  };
  cargoesFreeText?: {
    placeHolder: string;
  };
  button?: {
    text: string;
    type: string;
  };
}
